import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../components/Button';
import Select from '../../../../components/Select';
import useFetch from '../../../../services/useFetch';
import validate from './validation';

const propTypes = {
  onFilter: PropTypes.func.isRequired,
};

const fetchConfig = {
  initalMethod: 'get',
  initialUri: '/service/v1/health/plan/list',
  showSuccessMessage: false,
  showErrorMessage: false,
};

const fetchHealthCareConfig = {
  initalMethod: 'get',
  initialUri: '/service/v1/health/attention/list',
  showSuccessMessage: false,
  showErrorMessage: false,
};

const initialLists = {
  plan: [],
  planType: [],
  healthCare: [],
};

function FilterBar(props) {
  const { onFilter } = props;
  const fetch = useFetch(fetchConfig);
  const fetchHealthCare = useFetch(fetchHealthCareConfig);
  const filterParams = {
    plan: null,
    plan_type: null,
    attention: null,
  };
  const [filter, setFilter] = React.useState(filterParams);
  const [lists, setLists] = React.useState(initialLists);
  const [errors, setErrors] = React.useState({});

  async function fetchLists() {
    const config = {
      uri: '/service/v1/health/plan/list',
    };
    const [planResponse, healthCareResponse] = await Promise.all([
      fetch.fetch({}, config),
      fetchHealthCare.fetch(),
    ]);

    setLists(prevState => ({
      ...prevState,
      plan: planResponse.success
        ? planResponse.data.filter(el => !!el.value)
        : [],
      healthCare: healthCareResponse.success
        ? healthCareResponse.data.filter(el => !!el.value)
        : [],
    }));
  }

  React.useEffect(() => {
    fetchLists();
  }, []);

  async function fetchPlan(plan) {
    console.log('FETCH', plan);
    const config = {
      uri: `/service/v1/health/plan_type/${plan}/list`,
    };
    const response = await fetch.fetch({}, config);
    if (response.success) {
      setLists({
        ...lists,
        planType: response.data.filter(el => !!el.value),
      });
    }
  }

  function changeFilter(event) {
    const { target } = event;
    const { name, value } = target;

    console.log('VALUE', value);
    switch (name) {
      case 'plan':
        setFilter({
          ...filter,
          [name]: value,
          plan_type: null,
        });
        fetchPlan(value);
        break;
      default:
        setFilter({ ...filter, [name]: value });
        break;
    }
  }

  async function handleFilter() {
    setErrors({});
    const result = await validate(filter);
    if (!result.isValid) {
      setErrors(result.errors);
      return;
    }
    onFilter({
      ...filter,
      available_from: filter.available_from ? filter.available_from.toISOString() : null,
      available_to: filter.available_to ? filter.available_to.toISOString() : null,
    });
  }

  function handleReset() {
    setErrors({});
    setFilter(filterParams);
    onFilter({});
  }

  return (
    <Grid container item xs="auto" spacing={1}>
      <Grid item xs={12} sm={12} md>
        <Select
          label="Plan"
          name="plan"
          value={filter.plan || ''}
          onChange={changeFilter}
          options={lists.plan}
          labelKey="text"
          valueKey="value"
          margin="dense"
          error={!!errors.plan}
          helperText={errors.plan}
        />
      </Grid>
      <Grid item xs={12} sm={6} md>
        <Select
          label="Tipo de plan"
          name="plan_type"
          value={filter.plan_type || ''}
          onChange={changeFilter}
          options={lists.planType}
          labelKey="text"
          valueKey="value"
          margin="dense"
          error={!!errors.plan_type}
          helperText={errors.plan_type}
        />
      </Grid>
      <Grid item xs={12} sm={6} md>
        <Select
          label="Atención"
          name="attention"
          value={filter.attention || ''}
          onChange={changeFilter}
          options={lists.healthCare}
          labelKey="text"
          valueKey="value"
          margin="dense"
          error={!!errors.attention}
          helperText={errors.attention}
        />
      </Grid>
      <Grid item xs={6} md="auto">
        <Button color="primary" fullWidth square onClick={handleFilter}>Filtrar</Button>
      </Grid>
      <Grid item xs={6} md="auto">
        <Button color="secondary" fullWidth onClick={handleReset} square>Reiniciar</Button>
      </Grid>
    </Grid>
  );
}

FilterBar.propTypes = propTypes;

export default FilterBar;
